<template>
    <div>
      <table class="table bins-basic-info-table" style="background:transparent;height:100%;display:block">
        <thead style="color: #eee">
              <tr>
                <th scope="col" style="width: 20%"></th>
                <th scope="col" style="width: 80%"></th>
              </tr>
        </thead>
        <tbody>
            <tr>
              <td class="key-div" style="vertical-align: middle;">{{$t('Protocol Type')}}
                    <template v-if="strategyIndex == 0"> *</template>
              </td>
              <td class="value-div d-inline-flex float-left m-0 w-100">
                <div style="width: 62%;">
                  <div class="d-inline-flex" v-if="!isBinEditing('protocoltype')">
                      <span v-if="!isBinEditing('protocoltype') && selectedProtocol != undefined && selectedProtocol.length">{{selectedProtocol}}</span>
                      <span v-else-if="!isBinEditing('protocoltype')" class="empty-field-text-styles">NONE</span>
                    <edit-icon @click.native="editBasicBinInfoField('protocoltype')" v-show="!isBinEditing('protocoltype')" class="editIcon"></edit-icon>
                  </div>
                  <!-- <select v-model="selectedProtocol" @change="onChange($event)" v-show="isBinEditing('protocoltype')" class="rounded text-light comm-input-field-style align-input-field">
                      <option v-for="(item , index) in protocolList" v-bind:key="index">{{item}}
                      </option>
                  </select> -->
                  <Multiselect
                      v-show="isBinEditing('protocoltype')"
                      id="protocol_value"
                      :value="protocolDetails"
                      :options="protocolList"
                      :searchable="false"
                      :close-on-select="true"
                      :allow-empty="false"
                      deselectLabel=""
                      selectLabel=""
                      selectedLabel=""
                      :placeholder="$t('Select Protocol type')"
                      @select="updateProtocolType($event)"
                      style="float:inline-start"
                      track-by="_id"
                      label="label">
                      <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                          <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                      </div>
                      <span slot="noResult">No results.</span>
                  </Multiselect>
                </div>
                 <div v-show="isBinEditing('protocoltype')">
                     <div class="d-flex" style="height:100%;align-items:center;">
                       <save-icon @click.native="saveBasicBinInfoField('protocoltype')"></save-icon>
                       <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                     </div>
                 </div>
              </td>
            </tr>
            <template v-if="selectedProtocol == 'file'">
              <tr >
                <td class="key-div">{{$t('Path')}} *</td>
                <td class="value-div d-inline-flex float-left m-0 w-100">
                  <div style="width: 62%;">
                      <div class="d-inline-flex">
                          <span v-if="!isBinEditing('path') && updateBinInfo.path != undefined && updateBinInfo.path.length">{{updateBinInfo.path}}</span>
                          <span v-else-if="!isBinEditing('path')" class="empty-field-text-styles">NONE</span>
                          <edit-icon @click.native="editBasicBinInfoField('path')" v-show="!isBinEditing('path')" class="editIcon"></edit-icon>
                      </div>
                      <input type="text" v-show="isBinEditing('path')" placeholder="Enter path" v-model="updateBinInfo.path" class="rounded text-light comm-input-field-style align-input-field"/>
                  </div>
                  <div v-show="isBinEditing('path')">
                      <div class="d-flex">
                         <save-icon @click.native="saveBasicBinInfoField('path')"></save-icon>
                         <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                      </div>
                  </div>
                </td>
              </tr>
            </template>
            <template v-if="['ftp','smb'].includes(selectedProtocol)">
            <tr>
              <td class="key-div">{{$t('IP')}} *</td>
              <td class="value-div w-100 float-left m-0">
                  <div style="display: inline-flex;width: 74%;">
                      <div class="w-100">
                         <div class="d-inline-flex">
                             <span v-if="!isBinEditing('server') && binCredentails.server != undefined && binCredentails.server.length">{{binCredentails.server}}</span>
                             <span v-else-if="!isBinEditing('server')" class="empty-field-text-styles">NONE</span>
                              <edit-icon @click.native="editBasicBinInfoField('server')" v-show="!isBinEditing('server')" class="editIcon"></edit-icon>
                         </div>
                         <input type="text" @input="ipAddressValidationCheck" v-model="updateBinInfo.server" placeholder="Enter IP address" v-show="isBinEditing('server')" class="rounded text-light comm-input-field-style align-input-field"/>
                         <span v-show="!validIp && isBinEditing('server')" class="pl-1 pt-1 validationmessage">{{$t('Invalid IP Address')}}</span>
                      </div>
                      <div v-show="isBinEditing('server')">
                          <div class="d-flex">
                              <save-icon @click.native="saveBasicBinInfoField('server')"></save-icon>
                              <cancel-icon @click.native="cancelBasicBinInfoField('server')"></cancel-icon>
                          </div>
                      </div>
                  </div>
                  <div v-show="!isBinEditing('server')">
                      <span v-show="!validIp" class="pl-1 pt-1 validationmessage">{{$t('Invalid IP Address')}}</span>
                  </div>
              </td>
            </tr>
            </template>
            <template  v-if="['ftp','smb'].includes(selectedProtocol)">
             <tr>
                 <td class="key-div">{{$t('Backup IP')}}</td>
                 <td class="value-div w-100 float-left m-0">
                      <div style="display: inline-flex;width: 74%;">
                         <div class="w-100">
                             <div class="d-inline-flex">
                                 <span v-if="!isBinEditing('backup_server') && binCredentails.backup_server != undefined && binCredentails.backup_server.length">{{binCredentails.backup_server}}</span>
                                 <span v-else-if="!isBinEditing('backup_server')" class="empty-field-text-styles">NONE</span>
                                 <edit-icon @click.native="editBasicBinInfoField('backup_server')" v-show="!isBinEditing('backup_server')" class="editIcon"></edit-icon>
                             </div>
                             <input type="text" @input="backupIpAddressValidationCheck" v-model="updateBinInfo.backup_server" placeholder="Enter backup IP address" v-show="isBinEditing('backup_server')" class="rounded text-light comm-input-field-style align-input-field"/>
                             <span v-show="!validBackupIp && isBinEditing('backup_server')" class="pl-1 pt-1 validationmessage">{{$t('Invalid IP Address')}}</span>
                         </div>
                         <div v-show="isBinEditing('backup_server')">
                             <div class="d-flex">
                                 <save-icon @click.native="saveBasicBinInfoField('backup_server')"></save-icon>
                                 <cancel-icon @click.native="cancelBasicBinInfoField('backup_server')"></cancel-icon>
                             </div>
                         </div>
                     </div>
                     <div v-show="!isBinEditing('backup_server')">
                         <span v-show="!validBackupIp" class="pl-1 pt-1 validationmessage">{{$t('Invalid IP Address')}}</span>
                     </div>
                 </td>
              </tr>
            </template>
            <template v-if="selectedProtocol == 'ftp'">
              <tr >
                  <td class="key-div">{{$t('Port')}}</td>
                  <td class="value-div d-inline-flex float-left m-0 w-100">
                      <div style="width: 62%;">
                          <div class="d-inline-flex">
                              <span v-if="!isBinEditing('port')&& binCredentails.port != undefined">{{binCredentails.port}}</span>
                              <span v-else-if="!isBinEditing('port')" class="empty-field-text-styles">NONE</span>
                             <edit-icon @click.native="editBasicBinInfoField('port')" v-show="!isBinEditing('port')" class="editIcon"></edit-icon>
                          </div>
                          <input type="number" v-show="isBinEditing('port')" v-model.number="updateBinInfo.port" placeholder="Enter port" class="rounded text-light comm-input-field-style align-input-field"/>
                      </div>
                      <div v-show="isBinEditing('port')">
                         <div class="d-flex">
                             <save-icon @click.native="saveBasicBinInfoField('port')"></save-icon>
                             <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                          </div>
                      </div>
                  </td>
              </tr>
            </template>
            <template v-if="selectedProtocol == 'ftp'">
              <tr >
                  <td class="key-div">{{$t('Offset path')}} *</td>
                  <td class="value-div d-inline-flex float-left m-0 w-100">
                      <div style="width: 62%;">
                         <div class="d-inline-flex">
                             <span v-if="!isBinEditing('offset_path') && binCredentails.offset_path != undefined && binCredentails.offset_path.length">{{binCredentails.offset_path}}</span>
                              <span v-else-if="!isBinEditing('offset_path')" class="empty-field-text-styles">NONE</span>
                             <edit-icon @click.native="editBasicBinInfoField('offset_path')" v-show="!isBinEditing('offset_path')" class="editIcon"></edit-icon>
                         </div>
                          <input type="text" v-show="isBinEditing('offset_path')"
                          v-model="updateBinInfo.offset_path" placeholder="Enter Offset path" class="rounded text-light comm-input-field-style align-input-field"/>
                      </div>
                      <div v-show="isBinEditing('offset_path')">
                          <div class="d-flex">
                            <save-icon @click.native="saveBasicBinInfoField('offset_path')"></save-icon>
                            <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                          </div>
                      </div>
                  </td>
              </tr>
            </template>
            <template  v-if="selectedProtocol == 'smb'">
              <tr>
                  <td class="key-div">{{$t('Workgroup')}} *</td>
                  <td class="value-div d-inline-flex float-left m-0 w-100">
                      <div style="width: 62%;">
                          <div class="d-inline-flex">
                              <span v-if="!isBinEditing('workgroup') && binCredentails.workgroup != undefined && binCredentails.workgroup.length">{{binCredentails.workgroup}}</span>
                              <span v-else-if="!isBinEditing('workgroup')" class="empty-field-text-styles">NONE</span>
                              <edit-icon @click.native="editBasicBinInfoField('workgroup')" v-show="!isBinEditing('workgroup')" class="editIcon"></edit-icon>
                          </div>
                          <input type="text" v-show="isBinEditing('workgroup')"
                           v-model="updateBinInfo.workgroup" placeholder="Enter workgroup" class="rounded text-light comm-input-field-style align-input-field"/>
                      </div>
                      <div v-show="isBinEditing('workgroup')">
                          <div class="d-flex">
                              <save-icon @click.native="saveBasicBinInfoField('workgroup')"></save-icon>
                              <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                          </div>
                      </div>
                  </td>
              </tr>
            </template>
            <template v-if="selectedProtocol == 'smb'">
                  <tr>
                      <td class="key-div">{{$t('Remote name')}} *</td>
                      <td class="value-div d-inline-flex float-left m-0 w-100">
                          <div style="width: 62%;">
                              <div class="d-inline-flex">
                                  <span v-if="!isBinEditing('remote_name') && binCredentails.remote_name != undefined && binCredentails.remote_name.length">{{binCredentails.remote_name}}</span>
                                  <span v-else-if="!isBinEditing('remote_name')" class="empty-field-text-styles">NONE</span>
                                  <edit-icon @click.native="editBasicBinInfoField('remote_name')" v-show="!isBinEditing('remote_name')" class="editIcon"></edit-icon>
                              </div>
                              <input type="text" placeholder="Enter remote name" v-show="isBinEditing('remote_name')"  v-model="updateBinInfo.remote_name" class="rounded text-light comm-input-field-style align-input-field"/>
                          </div>
                          <div v-show="isBinEditing('remote_name')">
                              <div class="d-flex">
                                  <save-icon @click.native="saveBasicBinInfoField('remote_name')"></save-icon>
                                  <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                              </div>
                          </div>
                      </td>
                  </tr>
            </template>
            <template  v-if="selectedProtocol == 'smb'">
              <tr>
                 <td class="key-div">{{$t('Share name')}} *</td>
                 <td class="value-div d-inline-flex float-left m-0 w-100">
                      <div style="width: 62%;">
                          <div class="d-inline-flex">
                              <span v-if="!isBinEditing('sharename') && binCredentails.sharename != undefined && binCredentails.sharename.length">{{binCredentails.sharename}}</span>
                              <span v-else-if="!isBinEditing('sharename')" class="empty-field-text-styles">NONE</span>
                              <edit-icon @click.native="editBasicBinInfoField('sharename')" v-show="!isBinEditing('sharename')" class="editIcon"></edit-icon>
                          </div>
                          <input type="text" v-show="isBinEditing('sharename')"  placeholder="Enter share name" v-model="updateBinInfo.sharename" class="rounded text-light comm-input-field-style align-input-field"/>
                      </div>
                      <div v-show="isBinEditing('sharename')">
                          <div class="d-flex">
                              <save-icon @click.native="saveBasicBinInfoField('sharename')"></save-icon>
                              <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                          </div>
                      </div>
                  </td>
              </tr>
            </template>
            <template  v-if="['ftp','smb'].includes(selectedProtocol)">
              <tr >
                  <td class="key-div">{{$t('Username')}} *</td>
                  <td class="value-div d-inline-flex float-left m-0 w-100">
                      <div style="width: 62%;">
                          <div class="d-inline-flex">
                              <span v-show="!isBinEditing('username')">{{binCredentails.username}}</span>
                              <edit-icon @click.native="editBasicBinInfoField('username')" v-show="!isBinEditing('username')" class="editIcon"></edit-icon>
                          </div>
                          <input type="text" v-show="isBinEditing('username')" placeholder="Enter user name"  v-model="updateBinInfo.username" class="rounded text-light comm-input-field-style align-input-field"/>
                     </div>
                     <div v-show="isBinEditing('username')">
                         <div class="d-flex">
                              <save-icon @click.native="saveBasicBinInfoField('username')"></save-icon>
                              <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                          </div>
                     </div>
                  </td>
              </tr>
            </template>
            <template  v-if="['ftp','smb'].includes(selectedProtocol)">
              <tr >
                  <td class="key-div">{{$t('Password')}} *</td>
                  <td class="value-div w-100 float-left m-0">
                      <div style="display: inline-flex;width: 74%;">
                          <div class="w-100" style="position: relative">
                              <div class="d-inline-flex">
                                  <span v-show="!isBinEditing('password')">**********</span>
                                  <edit-icon @click.native="editBasicBinInfoField('password')" v-show="!isBinEditing('password')" class="editIcon"></edit-icon>
                              </div>
                              <input :type="verifypasswordFieldType" v-show="isBinEditing('password')" placeholder="Enter password" class="rounded text-light comm-input-field-style align-input-field" v-model="updateBinInfo.password"/>
                              <svg width="2em" height="1.5em" style="position: absolute; inset-inline-end :3%; bottom: 8px" v-show="isBinEditing('password')" @click="switchPasswordVisibility" type="password" viewBox="0 0 16 16" class="bi bi-eye ml-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"/>
                                  <path fill-rule="evenodd" d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                              </svg>
                          </div>
                          <div v-show="isBinEditing('password')">
                              <div class="d-flex">
                                  <save-icon @click.native="saveBasicBinInfoField('password')"></save-icon>
                                  <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                              </div>
                          </div>
                      </div>
                 </td>
              </tr>
            </template>
              <template v-if="['smb'].includes(selectedProtocol)">
                  <tr >
                      <td class="key-div">{{$t('SMB Version')}}</td>
                      <td class="value-div d-inline-flex float-left m-0 w-100">
                          <div style="width: 62%;">
                              <div class="d-inline-flex">
                                  <span v-show="!isBinEditing('smb_version')">
                                      <template v-if="'smb_version' in binCredentails">{{binCredentails.smb_version}}</template>
                                      <template v-else>3.1.1</template>
                                  </span>
                                  <edit-icon @click.native="editBasicBinInfoField('smb_version')" v-show="!isBinEditing('smb_version')" class="editIcon"></edit-icon>
                              </div>
                              <input type="text" v-show="isBinEditing('smb_version')" @input="smbVersionValidationCheck"
                                v-model="updateBinInfo.smb_version" class="rounded text-light comm-input-field-style align-input-field"/>
                              <span v-show="!validsmbVersion" class="pl-1 pt-1 validationmessage">{{$t('Invalid SMB Version')}}</span>
                              <div class="config-desc" style="text-align: start;">{{$t('Default SMB version is 3.1.1')}}</div>
                      </div>
                      <div v-show="isBinEditing('smb_version')">
                          <div class="d-flex">
                                  <save-icon @click.native="saveBasicBinInfoField('smb_version')"></save-icon>
                                  <cancel-icon @click.native="cancelBasicBinInfoField()"></cancel-icon>
                              </div>
                      </div>
                      </td>
                  </tr>
              </template>
             <tr v-if="selectedProtocol && selectedProtocol.trim().length > 0">
                  <td class="key-div">{{$t('Bin accessibility')}}</td>
                  <td class="text-success value-div">
                    <template v-if="initLoad">
                        <span style="position: relative;bottom: -2px;color:orange">Checking</span>
                    </template>
                    <template v-else-if="binEnabled">
                        <span class="text-success" style="position: relative;bottom: -2px;">CONNECTED</span>
                    </template>
                    <template v-else>
                        <span  class="text-danger" style="position: relative;bottom: -2px;">NOT CONNECTED</span>
                    </template>
                    <span class="text-primary border-0 status-check" @click="checkBinAcessAgain()">
                       Check connectivity
                    </span>
                  </td>
              </tr>
              <!-- <tr style="#bbb">
                 <td class="key-div p-2 align-middle" style="width:20%">Read Only</td>
                 <td class="value-div d-flex m-0 p-2" style="width:80%;"><input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes">
                 </td>
              </tr> -->
          </tbody>
      </table>
    </div>
</template>
  
<script>
  import { mapActions,mapMutations } from "vuex";
  import EditIcon from "../core/InlineEditField.vue";
  import SaveIcon from "../core/InlineSaveField.vue";
  import CancelIcon from "../core/InlineCancelField.vue";
  import Multiselect from 'vue-multiselect';
  import {NotifierConstants} from "../../components.constants.js";
  
  export default {
      props:["protocolType", "credentialsInfo", "", "binId", "strategyIndex"],
      data(){
          return{
            initLoad:true,
            binCredentails:{
                 "path":"",
                 "smb_version": "3.1.1"
            },
             editingBinKey: null,
             protocolDetails:{_id:"", label:""},
             protocolList:[
                {_id:"", label:""},
                {_id:"file",label:"file"},
                {_id:"ftp", label:"ftp"},
                {_id:"smb",label:"smb"},
                {_id:"aws", label:"AWS-S3-Cloud"}],
             binEnabled:false,
             selectedProtocol:"",
             actualProtocol:"",
             validIp:true,
             validBackupIp:true,
             validsmbVersion:true,
             updateBinInfo:{
                 "path":"",
                 "smb_version": "3.1.1"
             },
             verifypasswordFieldType: "password",
             ipAddressRegex: new RegExp(/^(?:(?:1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.){3}(?:1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/),
             smbVersionRegex:new RegExp(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/),
             domainNameRegex: new RegExp(/^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/),
          }
      },
      components: {
        "edit-icon": EditIcon,
        "save-icon": SaveIcon,
        "cancel-icon": CancelIcon,
        "Multiselect":Multiselect
      },
      watch:{
        protocolType(newVal, oldval){
            if(newVal != oldval){
                this.reloadCredentials()
            }
        },
        credentialsInfo(newVal, oldval){
            if(newVal != oldval){
                this.binCredentails = this.credentialsInfo
                this.updateBinInfo = this.credentialsInfo
                if(this.containsKey(this.credentialsInfo, 'protocol_accessibile')){
                    this.binEnabled = this.credentialsInfo["protocol_accessibile"]
                }else{
                    this.binEnabled = false
                }
            }
        }
      },
      methods:{
          getOffsetPath(){
              console.log("updateBinInfo",this.updateBinInfo)
              return this.updateBinInfo.offset_path;
          },
          switchPasswordVisibility(){
             this.verifypasswordFieldType = this.verifypasswordFieldType === 'password' ? 'text' : 'password';
          },
          validatedProtocol(){
            this.updateModifiedProtocol()
          },
          updateDefaultsValues(){
            let newProtocolInfo = {}
            if(this.selectedProtocol == 'file'){
                newProtocolInfo["path"] = "Empty"
            }else{
                newProtocolInfo["server"] = "10.10.10.10"
                newProtocolInfo["username"] = "Empty"
                newProtocolInfo["password"] = "Empty"
            }
            if(this.selectedProtocol == 'ftp'){
                newProtocolInfo["port"] = 21
                newProtocolInfo["offset_path"] = "Empty"
            }
            if(this.selectedProtocol == 'smb'){
                newProtocolInfo["sharename"] = "Empty"
                newProtocolInfo["remote_name"] = "Empty"
                newProtocolInfo["workgroup"] = "Empty"
                newProtocolInfo["smb_version"] = "3.1.1"
            }
            newProtocolInfo["enabled"] = true
            newProtocolInfo["protocol_accessibile"] = false
            this.updateBinInfo = newProtocolInfo
            this.binCredentails = this.updateBinInfo
          },
          updateModifiedProtocol(){
            let payload ={}
            if(!this.containsKey(this.updateBinInfo, this.selectedProtocol)){
                      this.initLoad = true
                      this.updateDefaultsValues()
                      this.binEnabled = false
                      let credentialsInfo = {}
                      if(this.selectedProtocol.trim().length > 0){
                          credentialsInfo[this.selectedProtocol] = this.updateBinInfo
                      }
                      if(this.selectedProtocol == 'aws'){
                        payload.cloud_protocol_credentials = {'aws':{}}
                      }else{
                        payload.protocol_credentials = credentialsInfo
                      }
                      this.$emit('update-protocol-strategy', payload, this.strategyIndex, this.selectedProtocol, true)
                      this.cancelBasicBinInfoField()
                      this.actualProtocol = this.selectedProtocol
                      setTimeout(()=>{
                        this.initLoad = false
                      }, 1000)
                      return
                  }
            this.cancelBasicBinInfoField()
            this.binCredentails = this.updateBinInfo
          },
          saveBasicBinInfoField(field){
              let payload ={}
              let binDetails=this.updateBinInfo
              if(field == "protocoltype" && this.selectedProtocol != this.actualProtocol){
                  this.$emit('validateNewProtocol', this.selectedProtocol, this.strategyIndex)
                  return
              }
              else{
                  if(["server","offset_path","path"].includes(field)){
                      if(typeof(this.updateBinInfo[field]) == "undefined" ||
                       this.updateBinInfo[field].trim() <= 0){
                          if(field == "path"){
                              alert("Please add valid path. ")
                          }else if(field == "server"){
                              alert("please add valid Ip. ")
                          }
                          return
                      }else if(field == "server" && !this.validIp){
                          alert("please add valid Ip. ")
                          return
                      }
                  }else if(field == "backup_server" && !this.validBackupIp){
                      alert("please add valid backup Ip. ")
                      return
                  }else if(field == "smb_version" && !this.validsmbVersion){
                      alert("please add valid smb version. ")
                      return
                  }
                  binDetails[field] = this.updateBinInfo[field]
                  let credentailsInfo = {}
                  if(!Object.keys(this.updateBinInfo).includes('enabled')){
                      binDetails['enabled'] = true
                  }
                  if(this.selectedProtocol != 'file'){
                    delete binDetails['path']
                  }
                  credentailsInfo[this.selectedProtocol] = binDetails
                  if(this.selectedProtocol == 'aws'){
                    payload.cloud_protocol_credentials = {'aws':{}}
                  }else{
                    payload.protocol_credentials = credentailsInfo
                  }
              }
              this.initLoad = true
              this.$emit('update-protocol-strategy', payload, this.strategyIndex, this.selectedProtocol, false)
              this.cancelBasicBinInfoField()
              this.binCredentails = binDetails
              setTimeout(()=>{
                this.initLoad = false
              }, 1000)
          },
          setFieldFocus(field){
              if(field == 'path'){
                  document.getElementById("field_path").scrollIntoView();
              }
          },
          getBinDetails(){
              let shareInfo = {}
              if(this.selectedProtocol == "file"){
                  shareInfo["path"] = this.updateBinInfo.path
              }
              else if(this.selectedProtocol == "ftp" || this.selectedProtocol == "smb"){
                  shareInfo["server"] = this.updateBinInfo.server
                  shareInfo["backup_server"] = this.updateBinInfo.backup_server
                  shareInfo["username"] = this.updateBinInfo.username
                  shareInfo["password"] = this.updateBinInfo.password
                  if(this.selectedProtocol == "ftp"){
                      shareInfo["port"] = this.updateBinInfo.port
                      if(typeof(shareInfo.port) == 'undefined'){
                          shareInfo["port"] = 21
                      }
                      shareInfo["offset_path"] = this.updateBinInfo.offset_path
                  }else{
                      shareInfo["workgroup"] =this.updateBinInfo.workgroup
                      shareInfo["sharename"] = this.updateBinInfo.shareInfo
                      shareInfo["smb_version"] = this.updateBinInfo.smb_version
                  }
              }
              return shareInfo
          },
          getSlectedProtocol(){
              return this.selectedProtocol
          },
          containsKey(obj, key ) {
              if(typeof(obj) == "undefined"){
                  return false
              }
              return Object.keys(obj).includes(key);
          },
          getValue(obj,key){
              if(typeof(obj) == "undefined" || obj == null){
                 if(key == "protocol_accessibile"){
                     this.updateBinInfo[key] = false
                     return false
                  }
                  this.updateBinInfo[key] = ''
                  return ''
              }
              if(this.containsKey(obj,key)){
                  this.updateBinInfo[key] = obj[key]
                  return obj[key]
              }
          },
          checkBinAcessAgain(){
            this.initLoad = true
              let payload = {params: {bin_id:this.binId, protocol_type: this.selectedProtocol}}
              this.reVerifyBinStatus(payload).then((data)=>{
                if('protocol_accessibile' in data){
                    this.initLoad = false
                    this.binEnabled = data["protocol_accessibile"]
                }
              });
          },
          ipAddressValidationCheck(){
              if (this.ipAddressRegex.exec(this.updateBinInfo.server) != null){
                 this.validIp = true;
              }else if(this.domainNameRegex.exec(this.updateBinInfo.server) != null){
                  this.validIp = true;
              } else {
                 this.validIp = false;
              }
          },
          backupIpAddressValidationCheck(){
              if (this.ipAddressRegex.exec(this.updateBinInfo.backup_server) != null){
                  this.validBackupIp = true;
              }else if(this.domainNameRegex.exec(this.updateBinInfo.backup_server) != null){
                  this.validBackupIp = true;
              } else {
                  this.validBackupIp = false;
              }
          },
          smbVersionValidationCheck(){
            if (this.smbVersionRegex.exec(this.updateBinInfo.smb_version) != null){
              this.validsmbVersion = true;
            } else {
              this.validsmbVersion = false;
            }
          },
          onChange(event){
              // this.selectedProtocol = event.target.value;
              this.selectedProtocol = event._id;
              if(this.selectedProtocol != this.actualProtocol){
                  this.updateDefaultsValues()
                  this.binEnabled = false
                  this.$emit("checkNewProtocolUpdate", this.selectedProtocol, this.strategyIndex)
              }else{
                  this.binEnabled = this.binCredentails["protocol_accessibile"]
              }
          },
          isBinEditing(keyName) {
              return keyName === this.editingBinKey;
          },
          editBasicBinInfoField(keyName) {
              this.editingBinKey = keyName;
              this.getValue(this.binCredentails,keyName)
          },
          updateProtocolType(option){
            this.protocolDetails = option
            this.selectedProtocol = option._id;
          },
          cancelBasicBinInfoField(keyName = null) {
              this.editingBinKey = null;
              this.selectedProtocol = this.protocolType;
              Object.assign(this.updateBinInfo,this.credentialsInfo)
              Object.assign(this.binCredentails, this.credentialsInfo)
              this.selectedProtocol = this.actualProtocol
              if(keyName && ["server","backup_server"].includes(keyName)){
                  this.updateBinInfo[keyName] = this.credentialsInfo[keyName]
                  if(keyName == 'server'){
                      this.ipAddressValidationCheck()
                  }else if(keyName == 'backup_server'){
                      this.backupIpAddressValidationCheck()
                  }
              }
          },
          reloadCredentials(){
            if(["file","ftp","smb","aws"].includes(this.protocolType)){
                this.selectedProtocol = this.protocolType;
                this.protocolDetails = this.protocolList.filter(op=>op._id == this.protocolType);
            }
            this.actualProtocol = this.selectedProtocol;
            if(typeof this.binCredentails != "undefined"){
                Object.assign(this.binCredentails, this.credentialsInfo);
                Object.assign(this.updateBinInfo,this.binCredentails);
                console.log("ddd",this.binCredentails.port)
            }
            if(this.containsKey(this.binCredentails, 'protocol_accessibile')){
                this.binEnabled = this.binCredentails["protocol_accessibile"]
            }else{
                this.binEnabled = false
            }
          },
          handleBinAccessibilityNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let bin_info = notification.message
                if(bin_info.bin_id == this.binId && Object.keys(bin_info.protocol_credentials).includes(this.selectedProtocol)){
                    this.initLoad = false
                    this.binEnabled = bin_info.protocol_credentials[this.selectedProtocol]['protocol_accessibile']
                }
            }
          },
          registerforWebsocketNotifications(){
            this.addWSEventListener({eventname:[NotifierConstants.binAccessibilityNotification],callback:this.handleBinAccessibilityNotification,parent: "BinCredentialInfo"})
            },
          UnregisterfromWebsocketNotifications(){
            this.removeWSEventListener({ eventname:[NotifierConstants.binAccessibilityNotification],callback:this.handleBinAccessibilityNotification,parent: "BinCredentialInfo"})
          },
          ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
          ...mapActions("bins", ["getBinInfoFromServer", "getBinStatus","reVerifyBinStatus"]),
      },
      created(){
          this.initLoad = true
          if(this.strategyIndex > 0){
            this.protocolList = [
                {_id:"", label:""},
                {_id:"file",label:"file"},
                {_id:"ftp", label:"ftp"},
                {_id:"smb",label:"smb"},
                {_id:"aws", label:"AWS-S3-Cloud"}]
          }else{
            this.protocolList = [
                {_id:"", label:""},
                {_id:"file",label:"file"},
                {_id:"ftp", label:"ftp"},
                {_id:"smb",label:"smb"},
                {_id:"aws", label:"AWS-S3-Cloud"}]
          }
          this.reloadCredentials()
          this.registerforWebsocketNotifications()
          setTimeout(() => {
            this.checkBinAcessAgain()
          }, 500)
          // let binStatusPayload = {
          //     "bin_id":this.binId
          // }
          // let payload ={}
          // payload.params = binStatusPayload
          // this.getBinStatus(payload).then((resp) => {
          // });
      }
  }
  </script>
  <style scoped lang="scss">
  $border-color: 1px solid #4a4a4a;
      $border-color-only:#4a4a4a;
      $primary-background: #1a1e21;
      $secondary-background-color:#15181B;
      $bg-color-on-hover: #22272b;
      $text-color: #eee;
      $dull-text-color: #757575;
      $secondary-text-color: #9c9c9c;
      $active-blue : #007bff;
      $input-field-and-label-font-size:14px;
      $danger-color: #dc3545 !important;
      $input-field-height:38px;
      $none-text-color:#4f4f4f;
      $input-field-padding:.375rem 10px;
      $scrollbar-thumb-background:#333;
      $scrollbar-track-background:#1a1e21;
      $scrollbar-thumb-on-hover-background:#555;
      $tags-background-color:#282d31;
      $button-height:38px;
      $tags-border-color:#363636;
      $metadata-border-color-on-hover: #5a5a5a;
      $secondary-border-color: 1px solid #2b2b2b;
      $active-green-color:#28a745;
      $svg-color:#666;
      $learn-about-text-color-hover:#b7b327;
      $active-green-icon-color: #00ff3a;
      $learn-about-text-color:#9a9620;
  
  
  svg{
    color:$dull-text-color;
  }
  
  .empty-field-text-styles{
    color:$none-text-color;
  }
  
  svg:hover{
    color:$text-color;
  }
  
  .comm-input-field-style{
      background: $primary-background!important;
      width: 100% !important;
      float: inline-start;
      padding: $input-field-padding;
      border: $border-color!important;
      font-size:$input-field-and-label-font-size;
      height: $input-field-height;
  }
  
  .align-input-field{
    margin-top:-8px;
  }
  
  h6 {
     width: 100%; 
     text-align: center; 
     border-bottom: 1px solid red; 
     line-height: 0.1em;
     margin: 10px 0 20px; 
  } 
  
  h6 span { 
      background:$text-color; 
      padding:0 10px; 
  }
  
  .config-desc{
    color: $dull-text-color;
    padding-inline-start: 12px;
  }
  
  .bins-basic-info-table{
    font-size: 15px;
    margin-inline-start: 7% !important;
    tbody {
      margin: 10px;
      .key-div {
        text-align: end;
        color: $dull-text-color;
      }
      .value-div {
        text-align: start;
        margin-inline-start: 10px;
        span{
          padding-inline-start:12px;
        }
      }
    }
  }
  
  .btn {
    font-size: 14px !important;
    height: 100%;
  }
  
  .border {
    border: $border-color !important;
  }
  .activeclass {
    color: $active-blue;
  }
  
  table {
    background: transparent;
    thead {
      th {
        color: $dull-text-color;
        border-top: none !important;
        border-bottom: none !important;
      }
    }
    tbody {
      color: $text-color;
      td {
        border-top: none !important;
      }
    }
  }
  
  table.bins-basic-info-table .editIcon {
    visibility: hidden;
  }
  table.bins-basic-info-table td.value-div:hover .editIcon {
    visibility: visible;
  }
  
  .custom-control-label::before {
    background-color: $primary-background;
  }
  
  /* width */
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }
  
  .validationmessage{
    color:$danger-color;
    font-size: 11px;
  }
  
  .editIcon {
    margin-inline-start: 9px;
  }
  
  .primary-btn-style {
    margin-top: 2px;
    button {
      height: 35px;
      width: 70px;
      position: relative;
      float: inline-start;
      inset-inline-start:20%;
      font-size:14px;
    }
  }
  
  ::v-deep{
    .multiselect{
          width:100% !important;
    }
    .multiselect__content-wrapper{
      display:none;
    }
    .multiselect__tag {
        background-color: $primary-background !important;
      }
      .multiselect__tags{
          background: $primary-background;
          border: $border-color;
      }
      .multiselect__option--highlight {
          background: $bg-color-on-hover !important;
      }
      .multiselect__content {
          background: $secondary-background-color !important;
      }
      .multiselect__input, .multiselect__single {
          background: transparent !important;
          color:$text-color;
      }
      .multiselect__tag-icon{
         color:$text-color !important;
      }
      .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
          background: $bg-color-on-hover !important;
          color: $text-color !important;
      }
      .multiselect__tag-icon:after{
         color:$secondary-text-color !important;
         font-size: 23px;
      }
      .multiselect *{
          font-size: $input-field-and-label-font-size !important;
          font-family: "Roboto", Arial, sans-serif !important;
      }
      .multiselect{
        color:$text-color !important;
        font-size: $input-field-and-label-font-size !important;
        width:70%;
        // margin: 0 auto;
        min-height: 38px;
        height: 38px;
      }
      .multiselect__option--selected{
          background: $bg-color-on-hover !important;
          color: $text-color;
      }
      .multiselect__content-wrapper{
              // border: 1px solid #292828 !important;
              border: $border-color !important;
              display: block;
              background: $secondary-background-color;
              width: 100%;
              max-height: initial !important;
              overflow: auto;
              border: $border-color;
              border-top: none;
              border-bottom-left-radius: 5px;
              border-bottom-right-radius: 5px;
              z-index: 50;
              -webkit-overflow-scrolling: touch;
          }
      .multiselect__select,.multiselect__current,.multiselect__option{
          line-height: 12px !important;
      }
      .multiselect--above .multiselect__content-wrapper{
         background: $secondary-background-color!important;
      }
      .multiselect__tags {
          background: transparent !important;
      }
  } 
  .status-check:hover {
    text-decoration-line: underline;
  }
  ::v-deep{
    .multiselect__content-wrapper{
      display:none;
    }
    .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
       background: $bg-color-on-hover !important;
    }
    .multiselect__content {
       background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color:$text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color  !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: 12px !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:40%;
    }
    .multiselect__option--selected{
       background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: relative;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
     .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
        height: $input-field-height;
        min-height: 38px;
    }
  }
  </style>